import { Component } from "@kluntje/core";
import { DebuggerService } from "@kluntje/services";
import { renderTemplate } from "Helper/renderHelper/renderTemplate";
import ArticleService from "Services/ArticleService";
export class SDEArticleOverviewContentBox extends Component {
  private get apiBaseUrl(): string {
    return this.getAttribute("api-base-url") ?? `${location.origin}/wp-json/wp/v2/posts`;
  }

  protected afterComponentRender(): void {
    this.init();
  }

  private async init() {
    const articleResponse = await ArticleService.getArticles({
      apiBaseUrl: this.apiBaseUrl,
      pageSize: 4,
      page: 1,
    });

    if (!articleResponse || articleResponse.resultCount === 0) {
      DebuggerService.warn("No articles found");
      this.remove();
      return;
    }

    const { contentTemplate } = await import("./sde-m-article-overview-content-box.template");
    renderTemplate(contentTemplate({ articles: articleResponse.results }), this, { clearSSRContent: true });
  }
}

customElements.define("sde-m-article-overview-content-box", SDEArticleOverviewContentBox);
